module.exports = __webpack_public_path__ + "static/media/user-astronaut.62264d29.svg";